import { MegaPromptName } from "@common/lib/chat-ai/mega-prompts";
import { PageRouteBuilder } from "@common/route/page-route-builder";
import { OrganisationsDashboardPageComponent } from "./organisations-dashboard-page.component";

export const organisationsDashboardPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-organisations-dashboard-page", OrganisationsDashboardPageComponent)
    .atUrl("/organisations")
    .withTitle("Organisations")
    .withMegaPrompt(MegaPromptName.AtRiskAccountsAnalysis)
    .withMegaPrompt(MegaPromptName.BillingTierAudit)
    .build();
